import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { hoursToMilliseconds } from 'date-fns';
import React from 'react';
import { useSelector } from 'react-redux';
import { RemainingTime } from './RemainingTime';
export const ShiftRemainingTime = ({ startTime }) => {
    const settings = useSelector(getSettings);
    const timeUntilShiftStart = startTime - Date.now();
    const timerHighlightStartTime = hoursToMilliseconds(settings.missionShiftStartHighlight.time);
    const isHighlightingDue = timeUntilShiftStart < timerHighlightStartTime;
    return React.createElement(RemainingTime, { startTime: startTime, variant: isHighlightingDue ? 'red' : 'default' });
};
